import { getLocale } from '@gamiphy/utils/locale';

/**
 * Format date
 * @param date
 */
export const formatDate = (date: string | Date): string => new Date(date).toLocaleDateString(getLocale());
export const fullMonthFormatDate = (date: string | Date): string => {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(getLocale(), { month: 'long', day: 'numeric', year: 'numeric' });
};
